import { IUserDetails } from "../interfaces/IUserDetails";
import { IViewConfig } from "../interfaces/IViewConfig";
import { languageView } from "../consts/LanguageView.const";
import { notificationsView } from "../consts/NotificationsView.const";
import { assessmentView } from "../consts/AssessmentView.const";
import { externalServicesView } from "../consts/ExternalServicesView.const";
import { privacyView } from "../consts/PrivacyView.const";
import { createTemporaryAccessView } from "./CreateTemporaryAccessView.function";
import { createProfileView } from "./CreateProfileView.function";

export const createSettingViews = (userDetails: IUserDetails): Array<Array<IViewConfig>> => {
    return [
        [createProfileView(userDetails), languageView, privacyView, notificationsView],
        [assessmentView, createTemporaryAccessView(userDetails.isTemporaryAccess), externalServicesView]
    ];
};
